import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({providedIn: 'root'})
export class ArticleService extends BaseService {

  private url = 'api/article';  // URL to web api

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  /**
   * 已读全部
   * @returns {Observable<any|any>}
   */
  readAll():Observable<any> {
    const url = `${this.getUrl()}/read-all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`readAll`)),
      catchError(this.handleError<any>(`headerQuery`))
    );
  }

  /**
   * 文章立即发布
   * */
  publishArticle(id):Observable<any> {
    const url = `${this.getUrl()}/publish-status/${id}/PUBLISHED`;
    return this.http.put<any>(url,{}).pipe(
      tap(_ => this.log(`publishArticle`)),
      catchError(this.handleError<any>(`publishArticle`))
    );
  }

  /**
   * 取消文章发布
   * */
  unPublishArticle(id):Observable<any> {
    const url = `${this.getUrl()}/publish-status/${id}/UNPUBLISHED`;
    return this.http.put<any>(url,{}).pipe(
      tap(_ => this.log(`unPublishArticle`)),
      catchError(this.handleError<any>(`unPublishArticle`))
    );
  }

}

